// This is generated.  Alter it in blockGroups/workflowPanes/types/WorkflowActionPane.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { actionUtils } = require('@sstdev/lib_metadata-config');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
const { merge } = require('lodash');
module.exports = {
  asDataDictionary: function asDataDictionary(
    hNode,
    context,
    parentAccessRestrictions,
  ) {
    const {
      children,
      workflowAction,
      foreignNamespace,
      foreignRelation,
      propertyName,
    } = hNode;

    // Use hNode.securityModifier to figure out access restrictions
    const accessRestrictions = actionUtils.getNodeAccessRestrictions(
      hNode,
      context,
      parentAccessRestrictions,
    );
    // If the context role or feature flags does not result in access to this (or sub) component
    // don't include any part of it in the data dictionary.
    if (accessRestrictions.hidden) return [{}, {}];

    // Process children (form elements) to get their partial type definitions
    // Each child returns a partialTypeDefinition with property schemas
    let [_subDataDictionary = {}, _partialTypeDefinition = {}] =
      children?.reduce(
        ([sdd, ptd], child) => {
          const [_subDataDictionary = {}, _partialTypeDefinition = {}] =
            context.extractFromChild(child, context, accessRestrictions);
          return [
            merge(sdd, _subDataDictionary),
            moduleRegistration.mergePartialTypeDefinitions(
              ptd,
              _partialTypeDefinition,
              context,
            ),
          ];
        },
        [{}, {}],
      ) ?? [{}, {}];

    // Build the action pane schema with workflowAction and child form element properties
    // The workflowAction identifies which action type this is (e.g., 'update_item_item')
    const actionPaneSchema = Type.Object(
      {
        workflowAction: Type.Optional(
          Type.String({
            title: 'Workflow Action',
            'x-dataType': 'string',
            'x-propertyName': 'workflowAction',
          }),
        ),
        ..._partialTypeDefinition,
      },
      {
        title: propertyName || workflowAction || 'Action',
        'x-dataType': 'object',
        'x-propertyName': propertyName,
        'x-workflowAction': workflowAction,
        'x-foreignNamespace': foreignNamespace,
        'x-foreignRelation': foreignRelation,
        additionalProperties: true,
      },
    );

    // Return the action pane schema in an array format for the parent to use in a Union
    // The parent WorkflowActionList will combine all action schemas using Type.Union (anyOf)
    return [_subDataDictionary, { _actionSchemas: [actionPaneSchema] }];
  },
};
moduleRegistration.registerHNodeType(
  'workflowPanes',
  'WorkflowActionPane',
  module.exports,
);
